import styled from "styled-components";

export const AddAdherenseStyle = styled.div`
    height: 100vh;
    width: 100%;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const WrapContent = styled.div`
    width: 75%;
    height: 80%;
    display: flex;
    flex-direction: column;
`

export const SesiImage = styled.img`
    width: 200px;
    height: 90px;
    margin: 0;
`

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    h1{
        color: #FF5742;
        font-size: 20px;
        font-weight: 900;
        margin: 0;
    }

    h2{
        margin: 0;
        color: #005CA9;
        font-size: 20px;
        font-weight: 500;
    }
`

export const HeaderCollum = styled.div`
    display: flex;
    flex-direction: column;
`

export const WrapTitleAndSmallText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: space-between;

    p{
        color: #428EFF;
        font-size: 15px;
        margin-top: 0;
        width: 500px;
    }

    img{
        cursor: pointer;
        width: 100px;
        margin-bottom: 20px;
    }
`

export const WrapTitleAndSmallText2 = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    p{
        color: #428EFF;
        font-size: 15px;
        margin-top: 0;
        width: 450px;
        cursor: pointer;

        &:hover{
            color:rgb(24, 78, 160);
        }
    }
`

export const DenyButton = styled.button`
    width: 160px;
    height: 60px;
    border: none;
    border-radius: 30px;
    background-color: #FEA69B;
    color: black;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
    }
`

export const SelectAllButton = styled.button`
    width: 200px;
    height: 60px;
    border: none;
    border-radius: 15px;
    background-color: #E0E0E0;
    color: black;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    font-size: 20px;
    align-items: center;
    justify-content: center;

    &:hover {
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
    }
`

export const WrapButtons = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`

export const AcceptButton = styled.button`
    padding: 20px;
    width: 16%;
    border: none;
    border-radius: 30px;
    background-color: #FF5641;
    color: white;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    align-self: flex-end;
    font-size: 15px;
    margin-top: 15px;

    &:hover {
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
    }
`

export const AddButton = styled.button`
    padding: 15px;
    width: 10%;
    border: none;
    border-radius: 30px;
    background-color: #FF5641;
    color: white;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    align-self: center;
    font-size: 15px;
    margin-left: 25px;
    margin-top: 5px;

    &:hover {
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
        background-color: darkgreen;
    }
`

export const AddAdherenseTitle = styled.h1`
    color: #005CA9;
    font-weight: 700;
    font-size: 45px;
    align-items: self-start;
`

export const WrapAdesao = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;  
    min-height: 500px;
    max-height: 80vh; 
    overflow-y: auto;
    gap: 20px;
    width: 100%; 
`;

export const LeftContent = styled.div`
    display: flex;
    flex-direction: column;

    h2{
        font-size: 18px;
        font-weight: 600;
        color: black;
        margin-left: 50px;
        margin-top: 0;
        margin-bottom: 0;
    }
`

export const RightContent = styled.div`
    display: flex;
    flex-direction: column;

    h1{
        color: #FF5742;
        font-size: 20px;
        font-weight: 700;
        margin-right: 80px;
    }
`
export const SelectionIndicator = styled.div<{ selected: boolean }>`
  width: 20px;
  height: 20px;
  background-color: ${({ selected }) => (selected ? "#087CDE" : "#C4C4C4")};
  border-radius: 50%;
  position: absolute;
  top: 45%;
  right: 15px;
`;

export const AdesaoCard = styled.div`
  width: 100%;
  min-height: 130px; 
  background-color: #F7F7F7;
  border-radius: 30px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative; 
  cursor: pointer;
  flex-shrink: 0; 

  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
  }
`;

export const BackButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  background: none;
  border: none;
  color: red;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: #003f7d;
  }

  svg {
    margin-right: 5px;
  }
`;

export const SelectContractText = styled.h1`
    color: black;
    font-size: 20px;
`

export const Observation = styled.p`
    color: black;
    font-size: 15px;
    margin: 0;
    margin-top: -9px;
    margin-bottom: 5px;
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  max-width: 100%;
  max-height: 320px;
  overflow-y: auto;
  padding: 10px;
    
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 10px;
  }

  scrollbar-width: thin;
  scrollbar-color: #bbb #f1f1f1;
`;


export const GridButtons = styled.button`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    padding: 10px;
    height: auto;
    border: none;
    border-radius: 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    cursor: pointer;

    &:hover{
        background-color: #D9D9D9;
    }
`
export const ConfirmButton = styled.button`
    align-self: flex-end;
    background-color: #FF5641;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    padding: 8px;
    border: none;
    border-radius: 50px / 40px;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
`

export const Progress = styled.div`
    align-self: flex-end;
    background-color: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 120px;
    padding: 8px;
    border: none;
    border-radius: 50px / 40px;

    h1{
        font-size: 15px;
        text-align: center;
        width: 200px;
    }
`
